'use strict';

import React from 'react'
import Spinner from 'react-spinkit'

export default class IstProgress extends React.Component {
  constructor(props) {
    super(props);
    let d_message;
    let d_spinnerName;
    if(this.props.message==null){
      d_message = 'しばらくお待ちください'
    }else{
      d_message = this.props.message
    }
    if(this.props.spinnerName == null){
      d_spinnerName = 'cube-grid'
    }else{
      d_spinnerName = this.props.spinnerName
    }

    this.state = {
      message:d_message,
      spinnerName:d_spinnerName
    }
  }


  render() {

    return(
      <div className='loading__progress__wrapper'>
        <div className='loading__message'>
          <span>{this.state.message}</span>
        </div>
        <div className='loading__progress'>
          <Spinner spinnerName={this.state.spinnerName} />
        </div>
      </div>
    );
  }


}



// WEBPACK FOOTER //
// ./src/jsx/common/components/progress.jsx